import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSessionUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await http.post("/auth/google/session", { session_id: sessionId });
        setSessionUser(data.user);
        window.history.replaceState(null, "", location.pathname);
        toast.success(`Welcome, ${data.user.name}`);
        const u = data.user;
        nav(u.role === "admin" ? "/admin" : u.role === "vendor" ? "/vendor" : u.role === "practitioner" ? "/practitioner/dashboard" : "/account", { replace: true, state: { user: u } });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [location, nav, setSessionUser]);

  return <div className="p-16 text-center text-sm text-[#5A6B5D]" data-testid="auth-callback">Signing you in…</div>;
}
